import { IonCol, IonContent, IonFooter, IonGrid, IonHeader, IonPage, IonRow, IonToolbar } from '@ionic/react';
import { Button, RadioButtonGroup, Separador, Subtitulo, Titulo } from 'app-principal-componentes-visuales';
import React, { useEffect, useState } from 'react'
import { capitalizeString } from '../../../utils/utils';
import "./Normalizacion.scss"
import { CORREGIDO, DUDOSO, NO_ENCONTRADO, NO_PARSEADO } from '../../../utils/constants';
interface IDatoInvalido {
    nombre: string;
    valor: string;
}

interface IDudaOption {
    barrio: string;
    calle: string;
    codigoPostal: number;
    localidad: string;
    partido: string;
    provincia: string;
    alturaDesde: number;
    alturaHasta: number;
}
interface IOpcion {
    datoInvalido: IDatoInvalido;
    opciones?: {
        duda: IDudaOption[]
    } 
    status: string;
}

interface INormalizacionProps {
    data: IOpcion | any,
    isWeb: boolean,
    onClick: (params?: any) => void,
    closeModal: () => void,
    isBarrioCerrado?: boolean
}

let selectedOption;

const Normalizacion = ({data, isWeb, onClick, closeModal, isBarrioCerrado}: INormalizacionProps) => {

    const [message, setMessage] = useState({title: "", subtitle: ""})
    const [options, setOptions] = useState([])
    const [selected, setSelected] = useState(false);
    const [selectedValue, setSelectedValue] = useState("");

    useEffect(() => {
        setErrorMessage(data.datoInvalido, data.status)
        if(data.status === DUDOSO){
            let optionsArray = data?.opciones?.duda?.map( (option, index) => ({...option, texto: `${capitalizeString(option.calle)}, ${capitalizeString(option.localidad)}`, value: index.toString(), onClick: () => handleOptionSelect(index) } ))
            setOptions(optionsArray)
        }
    }, [data])
    
    const setErrorMessage = (invalidData: IDatoInvalido, status: string) => {
        switch(status) {
            case NO_ENCONTRADO:
            case NO_PARSEADO:
                switch (invalidData.nombre) {
                    case "altura":
                        setMessage({ title: "¡Lo sentimos!", subtitle: `La altura ${invalidData.valor} no existe para la calle ingresada` })
                        return
                    case "calle":
                        setMessage({ title: "¡Lo sentimos!", subtitle: `No hemos podido encontrar ${isBarrioCerrado ? "el barrio cerrado" : "la calle"} ${invalidData.valor} ` })
                        return
                }
                break;
            case DUDOSO:
                switch (invalidData.nombre) {
                    case "altura":
                        setMessage({ title: "Encontramos similitud en la altura de la calle", subtitle: `Seleccioná la opción correcta.` })
                        return
                    case "calle":
                        setMessage({ title: `Encontramos similitud en el nombre ${isBarrioCerrado ? "del barrio cerrado" : "de la calle"}`, subtitle: `Seleccioná la opción correcta.` })
                        return
                }
                break;
            case CORREGIDO:
                let subtitleCorregido = '';
                if(isBarrioCerrado) {
                    const calleText = `Encontramos el barrio cerrado ${capitalizeString(data.direccionNormalizada.calle)} para el domicilio ingresado`;
                    subtitleCorregido = (data.direccionNormalizada.barrio === undefined || data.direccionNormalizada.barrio === '')
                        ? calleText.concat(".")
                        : calleText + ` en la localidad ${capitalizeString(data.direccionNormalizada.localidad)}`.concat(".");
                } else {
                    const calleText = `Encontramos la calle ${capitalizeString(data.direccionNormalizada.calle)} para el domicilio ingresado`;
                    subtitleCorregido = (data.direccionNormalizada.barrio === undefined || data.direccionNormalizada.barrio === '')
                        ? calleText.concat(".")
                        : calleText + ` en el barrio ${capitalizeString(data.direccionNormalizada.barrio)}`.concat(".");
                }
                setMessage({ title: "¿Es esta tu ubicación?", subtitle: subtitleCorregido })
                break;
            default:
                setMessage({ title: "¡Lo sentimos!", subtitle: `Hubo un error al normalizar la dirección.` })
                break;
            
        }
    }

    const handleOptionSelect = (e) => {
        selectedOption = data.opciones.duda.at(e);
        setSelectedValue(e.toString());
        setSelected(true);
    }

    const handleSelectClick = () => {
        if(data.status === DUDOSO){
            onClick(selectedOption);
        } else{
            onClick();
        }
    }

    return (
        <>
            <IonContent fullscreen className={ isWeb ? 'asistencia__normalizacion' : 'asistencia__normalizacion asistencia__normalizacion-mobile'}>
                <IonGrid className='asistencia__normalizacion__header'>
                    <IonRow>
                        <IonCol size="12" className="titulo" >
                            <Titulo titulo={message.title} fontSm id="asistencia-normalizacion-mensaje" />
                        </IonCol>
                        <IonCol size="12" className="titulo" >
                            <Subtitulo className='norm_subtitulo' titulo={message.subtitle} id="subtitulo-mensaje" />
                        </IonCol>
                    </IonRow>   
                </IonGrid>
                <IonGrid className='normalizacion_body'>
                    <IonRow className='radio_container'>
                        <RadioButtonGroup
                            valueSelected={selectedValue}
                            radioList={options}
                            id="radio-button-normalizacion"
                        />  
                    </IonRow>
                </IonGrid>
                <div className='asistencia__normalizacion__footer'>
                    <IonGrid>
                        <IonRow className='norm_button_container' >
                            <IonCol size='6'>
                                <Button
                                    onClick={closeModal}
                                    className='norm_button'
                                    label={data.status === DUDOSO ? "Volver" : "Omitir"}
                                />
                            </IonCol>
                            <IonCol size='6'>
                                <Button
                                    primary
                                    className='norm_button'
                                    onClick={handleSelectClick}
                                    label={data.status === DUDOSO ? "Seleccionar" : 
                                        data.status === NO_ENCONTRADO ? "Modificar" : "Corregir"}
                                    disable={data.status === DUDOSO && selected === false}
                                />
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </div>
            </IonContent> 
        </>
    )
};

export default Normalizacion;